import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mirin-verify',
  templateUrl: './mirin-verify.component.html',
  styleUrls: ['./mirin-verify.component.scss']
})
export class MirinVerifyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
